import {
    GET_ALL_CONTENT,
    GET_ALL_CONTENT_PENDING,
    GET_ALL_CONTENT_FULFILLED,
    GET_ALL_CONTENT_REJECTED
} from '../Actions/content';

const INITIAL_STATE = {
    isLoading: false,
    homepageContent: {},
    eventInfoContent: {},
    eventInfoOverviewContent: {},
    eventInfoItineraryContent: {},
    eventInfoVenuInfoContent: {},
    eventInfoAttendeesContent: {},
    myStampsContent: {},
};

export default function(state = INITIAL_STATE, action) {
    switch (action.type) {
        case GET_ALL_CONTENT:
            return {...state, isLoading: true};
        case GET_ALL_CONTENT_PENDING:
            return {...state, isLoading: true};
        case GET_ALL_CONTENT_FULFILLED:
            const [homepageContent, eventInfoContent, eventInfoOverviewContent, eventInfoItineraryContent, eventInfoVenueInfoContent, eventInfoAttendeesContent] = action.payload;
            return {...state, isLoading: false, homepageContent: homepageContent.data, eventInfoContent: eventInfoContent.data, eventInfoOverviewContent: eventInfoOverviewContent.data, eventInfoItineraryContent: eventInfoItineraryContent.data, eventInfoVenueInfoContent: eventInfoVenueInfoContent.data, eventInfoAttendeesContent: eventInfoAttendeesContent.data};
        case GET_ALL_CONTENT_REJECTED:
            return {...state, isLoading: false};
        default:
            return state;
    }
}